
import Component from 'vue-class-component'
import Vue from 'vue'
import {Inject, Prop, Watch} from 'vue-property-decorator'
import {Organisation} from '@/models/organisation'
import {sortStringValues} from '../../utils/utils'
import { State } from 'vuex-class'
import {User as Storeuser} from '@/store/index'

@Component({
  components: {},
})
export default class OrgForm extends Vue {
  @State public readonly user: Storeuser
  @Prop() public readonly allowNewEntries!: boolean
  @Prop() public organisations: Organisation[]
  @Prop() private orgOrUser!: Organisation
  @Prop() private isPending!: boolean
  private authorities: string[] = []
  private departments: string[] = []
  private entities: string[] = []
  private units: string[] = []

  private mounted() {
    this.populateFilterData()
  }

  private get hasAuthority() {
    return this.orgOrUser.authority !== '' && this.orgOrUser.authority !== null && this.orgOrUser.authority !== undefined
  }

  private get hasDepartment() {
    return this.orgOrUser.department !== '' && this.orgOrUser.department !== null && this.orgOrUser.department !== undefined
  }

  private get hasEntity() {
    return this.orgOrUser.entity !== '' && this.orgOrUser.entity !== null && this.orgOrUser.entity !== undefined
  }

  private get hasUnit() {
    return this.orgOrUser.unit !== '' && this.orgOrUser.unit !== null && this.orgOrUser.unit !== undefined
  }

  private clearedAuthority() {
    this.orgOrUser.authority = null
    this.orgOrUser.department = null
    this.orgOrUser.entity = null
    this.orgOrUser.unit = null
    this.populateFilterData()
  }

  private clearedDepartment() {
    this.orgOrUser.entity = null
    this.orgOrUser.unit = null
    this.populateFilterData()
  }

  private clearedEntity() {
    this.orgOrUser.unit = null
    this.populateFilterData()
  }

  @Watch('organisations')
  private updatedOrganisations() {
    this.populateFilterData()
  }

  private attributeIsValid(attribute: string | null | undefined) {
    return attribute !== '' && attribute !== null && attribute !== undefined
  }

  private evaluateDataForFilter(filterArray: string[], value: string | null) {
    if (value !== null && value !== '' && value !== undefined) {
      if (!filterArray.includes(value)) {
        filterArray.push(value)
      }
    }
  }

  private initializeData() {
    this.evaluateDataForFilter(this.authorities, this.orgOrUser.authority)
    this.evaluateDataForFilter(this.departments, this.orgOrUser.department)
    this.evaluateDataForFilter(this.entities, this.orgOrUser.entity)
    this.evaluateDataForFilter(this.units, this.orgOrUser.unit)
  }

  private resetFilterData() {
    this.authorities = []
    this.departments = []
    this.entities = []
    this.units = []
  }

  private sortFiltersValue() {
    sortStringValues(this.authorities)
    sortStringValues(this.departments)
    sortStringValues(this.entities)
    sortStringValues(this.units)
  }

  private populateFilterData() {
    this.resetFilterData()
    this.initializeData()
    this.organisations.forEach((org) => {
      switch (this.orgOrUser.authority) {
        case null:
        case '':
        case undefined:
          this.evaluateDataForFilter(this.authorities, org.authority)
          break
        case org.authority:
          switch (this.orgOrUser.department) {
            case null:
            case '':
            case undefined:
              this.evaluateDataForFilter(this.departments, org.department)
              break
            case org.department:
              switch (this.orgOrUser.entity) {
                case null:
                case '':
                case undefined:
                  this.evaluateDataForFilter(this.entities, org.entity)
                  break
                case org.entity:
                  switch (this.orgOrUser.unit) {
                    case null:
                    case '':
                    case undefined:
                      this.evaluateDataForFilter(this.units, org.unit)
                      break
                  }
              }
          }

      }
    })
    this.sortFiltersValue()
  }
}
